module.exports = __webpack_public_path__ + "img/dr-sotonyi-kata.09f737e6.jpg";